export default __webpack_public_path__ + "static/media/alcoholbook1.027e048b.jpg";